export enum Facing {
  East = 'East',
  West = 'West',
  North = 'North',
  South = 'South',
  Southeast = 'Southeast',
  Northeast = 'Northeast',
  Southwest = 'Southwest',
  Northwest = 'Northwest',
  WestNorth = 'WestNorth',
  WestSouth = 'WestSouth',
  EastSouth = 'EastSouth',
  EastNorth = 'EastNorth'
}
